function emptyValAsClass(element) {
    var jqueryElement = $(element);
    if (jqueryElement.val()) {
        jqueryElement.removeClass('empty');
    } else {
        jqueryElement.addClass('empty');
    }
}

function emptyOptionSelectedAsClass(element) {
    var jqueryElement = $(element);
    if (jqueryElement.children('option:selected').text().trim().length === 0) {
        jqueryElement.addClass('empty');
    } else {
        jqueryElement.removeClass('empty');
    }
}

function overrideValueProperty(element) {
    if (element.hasOwnProperty('value')) {
        return;
    }
    var realValueProperty = Object.getOwnPropertyDescriptor(element.__proto__, 'value');
    Object.defineProperty(element, "value", {
        get: function() {
            return realValueProperty.get.call(element);
        },
        set: function(newValue) {
            realValueProperty.set.call(element, newValue);
            $(element).trigger('valueChanged');
        }
    });
}

function overrideSelectedIndexProperty(element) {
    if (element.hasOwnProperty('selectedIndex')) {
        return;
    }
    var realSelectedIndexProperty = Object.getOwnPropertyDescriptor(element.__proto__, 'selectedIndex');
    Object.defineProperty(element, "selectedIndex", {
        get: function() {
            return realSelectedIndexProperty.get.call(element);
        },
        set: function(newValue) {
            realSelectedIndexProperty.set.call(element, newValue);
            $(element).trigger('selectedIndexChanged');
        }
    });
}

function applyEmptyValAsClass(element) {
    emptyValAsClass(element);
    overrideValueProperty(element);
    $(element).on('input propertychange valueChanged', function() {
        emptyValAsClass(element);
    });
}

function applyEmptyOptionSelectedAsClass(element) {
    emptyOptionSelectedAsClass(element);
    overrideSelectedIndexProperty(element);
    $(element).on('change selectedIndexChanged', function() {
        emptyOptionSelectedAsClass(element);
    });
}

$(function() {
    if(typeof ko !== 'undefined') {
        ko.bindingHandlers.emptyStateAsClass = {
            init: function (element) {
                var elementType = element.nodeName.toLowerCase();
                if (elementType === 'input' || elementType === 'textarea') {
                    applyEmptyValAsClass(element);
                } else if (elementType === 'select') {
                    applyEmptyOptionSelectedAsClass(element);
                }
            }
        };
    }
    var relevantInputsAndTextareas = $('.form-label-group input')
        .not('[type=hidden]')
        .not('[type=radio]')
        .not('[type=checkbox]')
        .not('[type=submit]')
        .not('[type=button]')
        .not('[type=file]')
        .add('.form-label-group textarea');
    relevantInputsAndTextareas.each(function(index, element) {
        applyEmptyValAsClass(element);
    });
    $('.form-label-group select').each(function(index, element) {
        applyEmptyOptionSelectedAsClass(element);
    });
});
